import { useParams } from 'react-router-dom';
import { TherapySearchForm } from './TherapySearchForm';
import { SUPPLIER_CATEGORY } from 'Enum/suppliers';
import { DoctorsSearchForm } from './DoctorsSearchForm';

export const SearchForms = () => {
  const supplierCategory = useParams().supplierCategory?.toLocaleLowerCase();

  switch (supplierCategory) {
    case SUPPLIER_CATEGORY.mentalTherapy:
      return <TherapySearchForm />;

    case SUPPLIER_CATEGORY.doctors:
      return <DoctorsSearchForm />;

    default:
      return <></>;
  }
};
